<div class="flex flex-column" *ngIf="genre">
  <div class="mb-4">
    <app-input type="text" [(model)]="genre.name"
               [required]="true"
               label="Titolo in italiano"
               [showLength]="false" [maxLength]="64"></app-input>
  </div>
  <div class="mb-4">
    <app-input type="text" [(model)]="genre.englishName"
               [required]="true"
               label="Titolo in inglese"
               [showLength]="false" [maxLength]="64"></app-input>
  </div>
  <div class="flex flex-row justify-content-between">
    <button pButton class="p-button-outlined" icon="pi pi-times" label="Annulla" (click)="close()"></button>
    <button pButton class="p-button-raised" icon="pi pi-save" label="Salva" (click)="save()"
            [disabled]="!isValid()"></button>
  </div>
</div>
